module.exports = __webpack_public_path__ + "img/loader-white.17408dc6.svg";